import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams, HttpRequest, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { AuthenticationService } from './authentication.service';
import { tap } from 'rxjs/operators';
// import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class ApiService {
  private endPointBaseurl: string;
  private contentType = 'application/json';
  // private headers: Headers;
  // options: RequestOptions;

  private httpOptions = {
    headers: null,
    // headers: new HttpHeaders({
    //   'Content-Type':  'application/json',
    //   // accessToken: ''
    // }),
    params: undefined
  };


  constructor(
    private http: HttpClient,
    private authenticationService: AuthenticationService) {
    this.endPointBaseurl = environment.appApiUrl;
  }


  private initHttpHeaders(includeAccessToken: boolean = true, responseType = 'json') {
    if (includeAccessToken) {
      this.httpOptions.headers = new HttpHeaders({
        'Content-Type': this.contentType,
        accessToken: this.authenticationService.userInfo != null && this.authenticationService.userInfo.AuthResult != null ? this.authenticationService.userInfo.AuthResult.AccessToken : null
      });
    } else {
      this.httpOptions.headers = new HttpHeaders({
        'Content-Type': this.contentType,
      });
    }
    (this.httpOptions as any).responseType = responseType;
  }


  public Get(relativeUrl: string, searchParams: HttpParams = null, includeAccessToken: boolean = true): Observable<any> {
    this.initHttpHeaders(includeAccessToken);
    if (searchParams) {
      this.httpOptions.params = searchParams;
    } else {
      this.httpOptions.params = undefined;
    }

    return this.http.get(this.endPointBaseurl + relativeUrl, this.httpOptions);
  }


  public Post(relativeUrl: string, bodyParam: any = null, includeAccessToken: boolean = true): Observable<any> {
    this.initHttpHeaders(includeAccessToken);
    this.httpOptions.params = undefined;
    // if (searchParams) {
    //   this.httpOptions.params = searchParams;
    // } else {
    //   this.httpOptions.params = undefined;
    // }

    const bodyVal = bodyParam != null ? JSON.stringify(bodyParam) : null;

    return this.http.post(this.endPointBaseurl + relativeUrl, bodyVal, this.httpOptions);
  }


  public Put(relativeUrl: string, searchParams: HttpParams = null, bodyParam: any, includeAccessToken: boolean = true): Observable<any> {
    this.initHttpHeaders(includeAccessToken);
    if (searchParams) {
      this.httpOptions.params = searchParams;
    } else {
      this.httpOptions.params = undefined;
    }

    const bodyVal = JSON.stringify(bodyParam);

    return this.http.put(this.endPointBaseurl + relativeUrl, bodyVal, this.httpOptions);
  }


  public Delete(relativeUrl: string, searchParams: HttpParams = null, includeAccessToken: boolean = true): Observable<any> {
    this.initHttpHeaders(includeAccessToken);
    if (searchParams) {
      this.httpOptions.params = searchParams;
    } else {
      this.httpOptions.params = undefined;
    }

    return this.http.delete(this.endPointBaseurl + relativeUrl, this.httpOptions);
  }


  public GetBlob(relativeUrl: string, searchParams: HttpParams = null, includeAccessToken: boolean = true): Observable<any> {
    this.initHttpHeaders(includeAccessToken, 'blob');
    if (searchParams) {
      this.httpOptions.params = searchParams;
    } else {
      this.httpOptions.params = undefined;
    }

    return this.http.get(this.endPointBaseurl + relativeUrl, this.httpOptions);
  }


  GetFullBlobRespone(relativeUrl: string, searchParams: HttpParams = null, includeAccessToken: boolean = true): Observable<any> {
    this.initHttpHeaders(includeAccessToken, 'blob');
    if (searchParams) {
      this.httpOptions.params = searchParams;
    } else {
      this.httpOptions.params = undefined;
    }

    //Used to return not only the blob but also the response raw result (that contains additional informations like file name)
    let cloneHttpOptions = {...this.httpOptions};
    (cloneHttpOptions as any).observe = 'response';

    return this.http.get(this.endPointBaseurl + relativeUrl, cloneHttpOptions);

    //ATTENTION: in order to get the file name in headers.get('content-disposition')
    //           you have to add in startup.cs of the API project the following (last line)
    //
    // services.AddCors(o => o.AddPolicy("MyPolicy", builder =>
    // {
    //     builder.AllowAnyOrigin()
    //            .AllowAnyMethod()
    //            .AllowAnyHeader()
    //            .WithExposedHeaders("content-disposition"); //Do not remove, it is used to get file name when downloading from blob
    // }));
  }


  public Upload(relativeUrl: string, formData: FormData, includeAccessToken: boolean = true) {
    return this.http.post(
      this.endPointBaseurl + relativeUrl,
      formData,
      { headers: new HttpHeaders({
        // 'Content-Type':  'multipart/form-data',
        accessToken: this.authenticationService.userInfo != null && this.authenticationService.userInfo.AuthResult != null ? this.authenticationService.userInfo.AuthResult.AccessToken : null
        }),
        reportProgress: true,
        observe: 'events'
      }
    );
  }

}
